import { css, cx } from "@emotion/css";

import { useStyles } from "@/hooks/useStyles.ts";
import { usePatientMonitoringContext } from "@/pages/patient-monitoring/PatientMonitoringState.tsx";
import { Queries } from "@/queries/Queries.ts";
import { Theme } from "@/theme/CreateTheme.ts";

import { AgentReinclusionSuggestionBanner } from "./AgentReinclusionSuggestionBanner";
import { DoctorRenewNudge } from "./DoctorRenewNudge";
import { NurseNoticeBanner } from "./NurseNoticeBanner";
import { NurseReinclusionRequestBanner } from "./NurseReinclusionRequestBanner";

export const PatientDetailNudges = () => {
  const state = usePatientMonitoringContext(s => s);
  const me = Queries.user.usePractitionerMe({});
  const { data: featureFlags } = Queries.user.useFeatureFlags({});
  const styles = useStyles(makeStyles);

  const renewNudgeActive = !!featureFlags?.["renewal-nudge"];

  if (me.qualification === "doctor") {
    return (
      <div className={styles.wrapper}>
        <NurseNoticeBanner patientId={state.patient.id} />
        <NurseReinclusionRequestBanner patientId={state.patient.id} />
        {renewNudgeActive && <DoctorRenewNudge patientId={state.patient.id} />}
      </div>
    );
  }

  // The reinclusion-agent feature is gated server-side per nurse: the banner self-hides
  // when the API returns no suggestion (flag off for this nurse, or nothing to suggest).
  // Rendered without the wrapper so no empty padded gap shows when it self-hides.
  if (me.qualification === "nurse") {
    return (
      <div className={cx(styles.wrapper)}>
        <AgentReinclusionSuggestionBanner patientId={state.patient.id} />
      </div>
    );
  }

  return null;
};

const makeStyles = (theme: Theme) => ({
  wrapper: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(8)};
    padding-bottom: ${theme.spacing(8)};
  `,
});
